module.exports = __webpack_public_path__ + "media/images/beauty/agnes-16b3b0902e1a4b6c41c40d08aaf06c4b.jpg";